const clientFilters = {
  name: null,
  active: null,
  invoiceFrequencyId: null,
  thirdPartyPortalId: null,
  includeInactive: null
}

export default () => Object.assign({}, clientFilters)
